<template>
  <v-card
    outlined
    tile
    elevation="0"
    class="pa-10">
    <div class="_fs-24">
      บัตรเครดิต/บัตรเดบิต
    </div>
    <v-form action="/upload-slip/checkout">
      <div
        v-if="orderResult.preVatAmount >= 1000"
        id="container-button-payment"
        class="text-center pa-16"
      />
      <p
        v-else
        class="all-rights-reserved">
        ขอสงวนสิทธิ์การจ่ายบัตรเครดิต เมื่อมียอดสั่งซื้อขั้นต่ำ 1,000 บาท
      </p>
    </v-form>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import configuration from '@/config'
import { roundDecimalDigits } from '@/utils/currency'

export default {
  name: 'BasePaymentCreditCard',
  props: {
    orderResult: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      initialButtonKPayment: false
    }
  },
  computed: {
    ...mapState('User', ['userProfile'])
  },
  watch: {
    orderResult: {
      deep: true,
      handler() {
        if (
          !this.initialButtonKPayment
          && this.orderResult
          && typeof this.orderResult === 'object'
          && Object.values(this.orderResult).length) {
          this.createButtonKPayment()
        }
      }
    }
  },
  async mounted() {
    setTimeout(() => {
      if (this.orderResult.preVatAmount >= 1000) {
        const script = document.createElement('script')

        script.setAttribute('type', 'text/javascript')
        script.setAttribute('src', configuration.K_PAYMENT_URL)
        script.setAttribute('data-apikey', configuration.K_PAYMENT_API_KEY)
        script.setAttribute('data-amount', roundDecimalDigits(this.orderResult.netTotal))
        script.setAttribute('data-payment-methods', 'card')
        script.setAttribute('data-mid', configuration.K_PAYMENT_MERCHANT_ID)
        script.setAttribute('data-name', 'LINE By Sellsuki')
        script.setAttribute('data-currency', 'THB')

        this.$utils.setKPaymentCheckout({
          ...this.orderResult
        })

        if (this.userProfile?.kpayment) {
          script.setAttribute('data-customer-id', this.userProfile.kpayment?.customerId)
        }

        script.onload = () => {
          const payButtons = document.getElementsByClassName('pay-button')

          if (payButtons.length === 0) {
            window.KPayment.create()
          }
        }

        document.getElementById('container-button-payment').append(script)
      }
    }, 1000)
  }
}
</script>

<style scoped>
.all-rights-reserved {
  color: red;
  font-size: 12px;
}
</style>
